<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <TableView
      :headers="headers"
      :items="merchants"
      :options.sync="options"
      :loading="loading"
      :totalData="totalMerchants"
      :refresh-table="getData"
      :bodyFilter="true"
      :customTopActions="true"
      item-key="id"
      table-height="70vh"
    >     
    <template v-slot:top>
      <div class="d-flex justify-end my-4 mr-6">
        <v-btn
          icon
          color="warning"
          class="mb-2 ml-2"
          @click="getData"
          :loading="loading"
          :disabled="loading"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </div>
      </template>
      <template v-slot:body-prepend>
        <tr>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.email"
              type="text"
              label="Email"
              v-on:keyup.enter="searchFilter"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
              clearable
              @click:clear="clearFilterData('email')"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-text-field
              v-model="search.subject"
              type="text"
              label="Subject"
              v-on:keyup.enter="searchFilter"
              hide-details="true"
              dense
              prepend-inner-icon="mdi-magnify"
              clearable
              @click:clear="clearFilterData('subject')"
            />
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-menu
              ref="dateMenuBDate"
              v-model="dateMenuBDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="bdateFormatted"
                  label="Broadcast Date"
                  v-bind="attrs"
                  @blur="search.created_at = parseDate(bdateFormatted)"
                  v-on="on"
                  hide-details="true"
                  dense
                  clearable
                 @click:clear="clearFilterData('broadcast_date')"
                />
              </template>
              <v-date-picker
                v-model="search.broadcast_date"
                no-title
                scrollable
                @input="dateMenuBDate = false"
              >
                <v-spacer />
                <v-btn text color="primary" @click="dateMenuBDate = false">
                  Cancel
                </v-btn>
              </v-date-picker>
            </v-menu>
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-menu
              ref="dateMenuCDate"
              v-model="dateMenuCDate"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="cdateFormatted"
                  label="Created Date"
                  v-bind="attrs"
                  @blur="search.created_at = parseDate(cdateFormatted)"
                  v-on="on"
                  hide-details="true"
                  dense
                  clearable
                 @click:clear="clearFilterData('created_at')"
                />
              </template>
              <v-date-picker
                v-model="search.created_at"
                no-title
                scrollable
                @input="dateMenuCDate = false"
              >
                <v-spacer />
                <v-btn text color="primary" @click="dateMenuCDate = false">
                  Cancel
                </v-btn>
              </v-date-picker>
            </v-menu>
          </td>
          <td class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row">
            <v-autocomplete
              clearable
              v-model="search.created_by"
              :items="itemsActiveUser"
              item-text="userID"
              item-value="id"
              label="Created By"
              :loading="loadingActiveUser"
              :search-input.sync="searchActiveUser"
              @change="searchFilter"
              hide-selected
              hide-details="true"
              dense
            />
          </td>
          <td
            class="pa-3 d-block d-sm-table-cell d-print-table-cell fixed-row"
          />
        </tr>
      </template>

      <template v-slot:action="{ item }">
        <v-menu offset-y rounded="lg" transition="slide-y-transition" bottom left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="warning" class="mb-2" icon dark v-bind="attrs" v-on="on">
          <v-icon light size="20">mdi-dots-horizontal</v-icon>
        </v-btn>
      </template>
      <v-list dense>
     <v-list-item link :to="`/broadcast/broadcast/view/${item.id}`">
                  <v-list-item-icon>
                    <v-icon>mdi-eye</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>View</v-list-item-title>
                </v-list-item>
                <v-list-item
                  link
                  :to="`/broadcast/broadcast/edit/${item.id}`"
                  :disabled="item.disabled"
                >
                  <v-list-item-icon>
                    <v-icon :disabled="item.disabled">mdi-pencil</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Edit</v-list-item-title>
                </v-list-item>
                <v-list-item
                  link
                  @click="
                    () => {
                      openDialogConfirmation(item.id);
                    }
                  "
                  :disabled="item.disabled"
                >
                  <v-list-item-icon>
                    <v-icon :disabled="item.disabled">mdi-delete</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Delete</v-list-item-title>
                </v-list-item>

      </v-list>
    </v-menu>
      </template>
      </TableView>
    <v-dialog v-model="dialogConfirmation" width="500" persistent>
      <v-card>
        <v-card-title>
          Are you sure want to delete this broadcast ?
        </v-card-title>
        <v-card-text> Caution: this action cannot be undone ! </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn dark color="red" @click="() => (dialogConfirmation = false)">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            @click="deleteHistory"
            :disabled="loading"
            :loading="loading"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import broadcastHistoryMixin from '../../components/broadcast-management/broadcast-history/broadcastHistoryMixin';

export default {
  mixins: [broadcastHistoryMixin],
  components: {
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
  },

};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
